import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Apple = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" data-test="icon-apple" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.576 13.2871C17.5943 11.5908 18.4835 10.0232 19.93 9.13705C19.0116 7.83371 17.5364 7.03491 15.943 6.97805C14.243 6.80605 12.633 7.97805 11.771 7.97805C10.909 7.97805 9.582 7.00005 8.176 7.02805C6.29633 7.08143 4.58327 8.11952 3.666 9.76105C1.745 13.0951 3.176 18.0371 5.049 20.7431C5.963 22.0661 7.056 23.5531 8.488 23.4981C9.869 23.4441 10.388 22.6061 12.059 22.6061C13.73 22.6061 14.195 23.4981 15.659 23.4711C17.144 23.4441 18.085 22.1231 18.993 20.7951C19.6432 19.8399 20.1518 18.7958 20.503 17.6951C18.7346 16.9421 17.5838 15.2091 17.576 13.2871V13.2871Z"
      stroke={getColor(color, isColorInherited)}
      fill={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.01 4.173C15.8774 3.15423 16.3076 1.83423 16.207 0.5C14.8965 0.626354 13.6839 1.24926 12.818 2.241C11.9471 3.21364 11.5077 4.49773 11.6 5.8C12.9278 5.81726 14.1881 5.21595 15.01 4.173Z"
      stroke={getColor(color, isColorInherited)}
      fill={getColor(color, isColorInherited)}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
